var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('layout',{attrs:{"canLogOut":false,"userActions":_vm.actions}},[_c('router-view')],1),_c('modal-container'),_c('snackbar-container'),_c('Logout')],1)}
var staticRenderFns = []

export { render, staticRenderFns }